import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions } from 'ducks/uiOperations';
import { selectors as suppliersSelectors, actions as suppliersActions } from 'ducks/inventoryEnquiry/reordering/suppliers';
import { selectors as productSelectors } from 'ducks/SearchLookUp/productLookup';
import { search } from 'api/inventoryEnquiry/reordering/suppliers';
import { actions as filterActions, selectors as filterSelectors } from 'ducks/common/filters';
import { actions as formActions } from 'ducks/form';

const params = new URLSearchParams(location.search);

export const mapStateToProps = state => ({
  gridName: 'IESuppliers',
  columnDefs: suppliersSelectors.columns(state),
  rowData: suppliersSelectors.data(state),
  isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state),
  gridOptions: suppliersSelectors.gridOptions(state),
  isLoading: suppliersSelectors.isLoading(state),
  filterRow: suppliersSelectors.filterRow(state),
  selectedFilters: suppliersSelectors.selectedFilters(state),
  reqParams: (productSelectors.selected(state) || params.get('ProductId')) && {
    ProductId: (productSelectors.selected(state) && productSelectors.selected(state).ProductId) || params.get('ProductId')
  },
  appliedFilters: suppliersSelectors.filterRow(state) && filterSelectors.getFilters(state, suppliersSelectors.filterRow(state).formName),
  apiMethod: search
})

export const actions = {
  getFormSchema: formActions.search,
  changeSelectedForm: formActions.setSelected,
  changeSelectedTab: uiActions.changeSelectedTab,
  setSelectedOrderLine: suppliersActions.setSelected,
  changeOperationMode: operationActions.changeOperationMode,
  applyFilters: filterActions.applyFilters
}
